
<div class="row c-container-item-options">
  <!-- Width Control -->
  <div class="mb-3">
    <cvt-select
      mode="dropdown"
      :value="widthType"
      :label="'Width'"
      :background-mode="mode"
      @input="(value) => updateWidthType(value)"
    >
      <option value="default" v-text="'Default'" />
      <option value="full-width" v-text="'Full Width (100%)'" />
      <option value="inline-auto" v-text="'Inline Auto'" />
      <option value="custom" v-text="'Custom'" />
    </cvt-select>
  </div>

  <!-- Custom Width Input (shown when custom is selected) -->
  <div v-if="widthType === 'custom'" class="mb-3">
    <div class="row">
      <div class="col-8">
        <cvt-input
          type="number"
          :value="customWidthValue"
          :label="'Custom Width'"
          :placeholder="'Enter width value'"
          @input="(value) => updateCustomWidthValue(value)"
        />
      </div>
      <div class="col-4">
        <cvt-select
          mode="dropdown"
          :value="customWidthUnit"
          :label="'Unit'"
          :background-mode="mode"
          @input="(value) => updateCustomWidthUnit(value)"
        >
          <option value="px" v-text="'px'" />
          <option value="%" v-text="'%'" />
          <option value="rem" v-text="'rem'" />
          <option value="em" v-text="'em'" />
        </cvt-select>
      </div>
    </div>
  </div>

  <!-- Height Control -->
  <div v-if="canConfigureHeight" class="mb-3">
    <cvt-select
      mode="dropdown"
      :value="heightType"
      :label="'Height'"
      :background-mode="mode"
      @input="(value) => updateHeightType(value)"
    >
      <option value="auto" v-text="'Auto'" />
      <option value="full-height" v-text="'Full Height (100%)'" />
      <option value="custom" v-text="'Custom'" />
    </cvt-select>
  </div>

  <!-- Custom Width Input (shown when custom is selected) -->
  <div v-if="canConfigureHeight && heightType === 'custom'" class="mb-3">
    <div class="row">
      <div class="col-8">
        <cvt-input
          type="number"
          :value="customHeightValue"
          :label="'Custom Height'"
          :placeholder="'Enter height value'"
          @input="(value) => updateCustomHeightValue(value)"
        />
      </div>
      <div class="col-4">
        <cvt-select
          mode="dropdown"
          :value="customHeightUnit"
          :label="'Unit'"
          :background-mode="mode"
          @input="(value) => updateCustomHeightUnit(value)"
        >
          <option value="px" v-text="'px'" />
          <option value="%" v-text="'%'" />
          <option value="rem" v-text="'rem'" />
          <option value="em" v-text="'em'" />
        </cvt-select>
      </div>
    </div>
  </div>

  <!-- Align Self Control -->
  <div class="mb-3">
    <cvt-select
      mode="dropdown"
      :value="alignSelf"
      :label="'Align Self'"
      :background-mode="mode"
      @input="(value) => updateAlignSelf(value)"
    >
      <option value="auto" v-text="'Auto'" />
      <option value="flex-start" v-text="'Flex Start'" />
      <option value="flex-end" v-text="'Flex End'" />
      <option value="center" v-text="'Center'" />
      <option value="stretch" v-text="'Stretch'" />
      <option value="baseline" v-text="'Baseline'" />
    </cvt-select>
  </div>

  <!-- Size Controls -->
  <div class="mb-3">
    <label class="form-label">Size</label>
    <cvt-radio-group
      orientation="horizontal"
      :initial-value="sizeType"
      class="row"
    >
      <cvt-radio-button size="md" value="grow" @radioClick="updateSizeType">
        Grow
      </cvt-radio-button>
      <cvt-radio-button size="md" value="shrink" @radioClick="updateSizeType">
        Shrink
      </cvt-radio-button>
      <cvt-radio-button size="md" value="custom" @radioClick="updateSizeType">
        Custom
      </cvt-radio-button>
    </cvt-radio-group>

    <!-- Custom Size Inputs (shown when custom is selected) -->
    <div v-if="sizeType === 'custom'" class="custom-size-inputs mt-3">
      <div class="row">
        <div class="col-6">
          <cvt-input
            type="number"
            :value="flexGrow"
            :label="'Flex Grow'"
            :placeholder="'Enter flex grow value'"
            @input="(value) => updateCustomFlexGrow(value)"
          />
        </div>
        <div class="col-6">
          <cvt-input
            type="number"
            :value="flexShrink"
            :label="'Flex Shrink'"
            :placeholder="'Enter flex shrink value'"
            @input="(value) => updateCustomFlexShrink(value)"
          />
        </div>
      </div>
    </div>
  </div>
</div>
